import { render, staticRenderFns } from "./MIssueReportContactDetails.vue?vue&type=template&id=715fab35&lang=pug&"
import script from "./MIssueReportContactDetails.vue?vue&type=script&lang=js&"
export * from "./MIssueReportContactDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports